import React, { useEffect } from "react";
import crypto from "./projects/crypto.png";
import wordle from "./projects/wordle.png";
import blog from "./projects/blog.png";
import netflix from "./projects/netflix.png";
import sqlgen from "./projects/sqlgen.png";
import vidquery from "./projects/vidquery.png";
import prompt from "./projects/prompt.png";
import "./carausel.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const Carausel = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray("section").forEach((section, index) => {
      const w = section.querySelector(".wrapper");
      const [x, xEnd] =
        index % 2
          ? [w.scrollWidth * -1, 0]
          : ["100%", (w.scrollWidth - section.offsetWidth) * -1];
      gsap.fromTo(
        w,
        { x },
        {
          x: xEnd,
          scrollTrigger: {
            trigger: section,
            scrub: 0.5,
          },
        }
      );
    });
  }, []);
  return (
    <>
      <div className="sm:my-20">
        <section className="demo-gallery">
          <ul className="wrapper">
            <li>
              <img alt="" src={sqlgen} className="imgcar" />
            </li>
            <li>
              <img alt="" src={prompt} className="imgcar" />
            </li>
            <li>
              <img alt="" src={crypto} className="imgcar" />
            </li>
            <li>
              <img alt="" src={blog} className="imgcar" />
            </li>
            {/* <li>
              <img alt=''src={wordle} className="imgcar" />
            </li>
            <li>
              <img alt=''src={vidquery} className="imgcar" />
            </li> */}
          </ul>
        </section>

        <section className="demo-gallery">
          <ul className="wrapper">
            <li>
              <img alt="" src={blog} className="imgcar" />
            </li>
            <li>
              <img alt="" src={vidquery} className="imgcar" />
            </li>
            <li>
              <img alt="" src={wordle} className="imgcar" />
            </li>
            <li>
              <img alt="" src={netflix} className="imgcar" />
            </li>
            {/* <li>
              <img alt=''src={netflix} className="imgcar" />
            </li>
            <li>
              <img alt=''src={crypto} className="imgcar" />
            </li> */}
          </ul>
        </section>
        <section className="demo-text">
          <div className="wrapper text">Love to Create!</div>
        </section>
        {/* <section className="demo-text">
          <div className="wrapper text">ABCDEFGHIJKLMNOPQRSTUVWXYZ</div>
        </section> */}
      </div>
    </>
  );
};

export default Carausel;
